// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig = {
    title: 'chart.twitter.avg_engagement_rate_history',
    margin: { left: -20, right: 25 },
    name: {
        date: 'date',
        value: 'chart.twitter.avg_engagement_rate_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    color: {
        value: 'aquablue'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    tooltip: 'chart.twitter.tooltip_avg_engagement_rate_history',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
